Sentry.init({
  dsn: 'https://36e6a43e9b3a49ec96f759b09b383029@sentry.io/1469269',
  integrations: [
    new Sentry.Integrations.Vue({
      Vue,
      attachProps: true
    })
  ]
});
